export * from './isSelfCompany.types';
export { default as isSelfCompany } from './isSelfCompany';
